import { use } from 'react';
import { NotificationData } from '../notification-data';
import { NotificationHandlerContext } from '../NotificationHandlerContext';

const useNotifications = (): NotificationData[] => {
  const { notifications } = use(NotificationHandlerContext);

  return notifications;
};

export default useNotifications;
